import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId:'81lia9i4',
  dataset: 'production',
  apiVersion: '2023-09-01',
  useCdn: false,
  token: process.env.Token
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);